import { Mic, Plus } from "lucide-react";
import { Button } from "./ui/Button";
import { GlobalSearchButton } from "./GlobalSearch";
import { Kbd } from "./ui/Kbd";
import { useTaskStore } from "../stores/taskStore";
import { useUiStore } from "../stores/uiStore";
import { haptic } from "../lib/haptics";

function KpiCard({ label, value, sub, accent }: { label: string; value: number; sub: string; accent: string }) {
  return (
    <div className="min-w-28 border-l-2 pl-4" style={{ borderColor: accent }}>
      <div className="text-xs font-medium text-muted dark:text-muted-dark">{label}</div>
      <div className="font-mono text-4xl font-bold tracking-tight">{value}</div>
      <div className="text-xs text-muted dark:text-muted-dark">{sub}</div>
    </div>
  );
}

export function TopHeader() {
  const stats = useTaskStore((s) => s.stats);
  const setEditorOpen = useUiStore((s) => s.setEditorOpen);
  const setVoiceOpen = useUiStore((s) => s.setVoiceOpen);
  return (
    <header className="px-8 pb-6 pt-8">
      <div className="flex items-end justify-between gap-6">
        <div className="flex gap-8">
          <KpiCard label="アクティブ" value={stats.active} sub="残っています" accent="#6366F1" />
          <KpiCard label="今日完了" value={stats.completed} sub="完了済み" accent="#10B981" />
          <KpiCard label="高優先" value={stats.high} sub="集中対象" accent="#F59E0B" />
        </div>
        <div className="flex items-center gap-2">
          <GlobalSearchButton />
          <button
            type="button"
            onClick={() => { haptic("medium"); setVoiceOpen(true); }}
            title="音声でタスクを追加 (Hermes proxy → Grok)"
            className="flex h-11 items-center gap-2 rounded-md border-2 border-brand-500 bg-brand-500/10 px-4 text-sm font-semibold text-brand-700 transition hover:bg-brand-500/20 dark:border-brand-400 dark:text-brand-200"
          >
            <Mic className="h-4 w-4" />
            音声 (AI)
          </button>
          <Button size="lg" variant="primary" leftIcon={<Plus className="h-4 w-4" />} onClick={() => setEditorOpen(true)}>新規タスク</Button>
          <Kbd>⌘N</Kbd>
        </div>
      </div>
    </header>
  );
}
